export enum CheckPageAccess{
    DASHBOARDADMIN,
    DASHBOARDPARTICIPANT,
    USERMANAGEMENT,
    ADDUSER,
    EDITUSER,
    INVITATIONMANAGEMENT,
    BBINVITATIONS,
    ADDBBINVITATION,
    EDITBBINVITATION,
    LLTTFINVITATIONS,
    ADDLLTTFINVITATION,
    EDITLLTTFINVITATION,
    COURSEMANAGEMENT,
    TAGS,
    ADDTAG,
    EDITTAG,
    MATERIALS,
    ADDMATERIAL,
    EDITMATERIAL,
    COURSES,
    ADDCOURSE,
    EDITCOURSE,
    REPORTING,
    ORGMANAGEMENT,
    EMAILQUEUE,
    ROLEONBOARDING,
    ADDROLEONBOARDING,
    EDITROLEONBOARDING,
    ONBOARDINGTRAINING,
    BULKIMPORT,
    MYTRAINING
}
